import toDigit from './toDigit';

/**
 * CEP como texto so com digitos, limitado a 8. O limite vale sobre os digitos, e nao sobre os
 * caracteres digitados: colar "01001-000" (9 caracteres) precisa resultar em "01001000".
 * Mantem o zero a esquerda (nao converte para Number).
 */
export default function toZipCodeDigits(value?: string | null): string {
  return (toDigit(value) || '').slice(0, 8);
}
